<template>

  <v-select 
    :value="selected"
    @input="change"
    :options="options"
    :placeholder="placeholder"
    :clearable="clearable">
    </v-select>

</template>

<script>
import moment from 'moment'

export default {
  name: 'SelectDuration',
  props: {
    value: {
      type: Number
    },
    placeholder: {
      type: String
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
    }
  },
  computed: {
    options () {
      let times = []
      for (let i = 1; i <= (4 * 6); i++) {
        const min = i * 15
        const time = moment().set({ hour: 0, minute: min, second: 0, millisecond: 0 })
        const hours = time.format('HH') > 0 ? this.$tc('n_hours', time.format('HH'), { count: time.format('HH') }) : ''
        const minutes = time.format('mm') > 0 ? this.$tc('n_minutes', time.format('mm'), { count: time.format('mm') }) : ''
        times.push({
          label: String(hours + minutes).trim(),
          value: min
        })
      }
      return times
    },
    selected () {
      return this.options.find((val) => {
        return val.value === this.value
      })
    }
  },
  methods: {
    change (val) {
      const value = val ? val.value : null
      if (value !== this.value) {
        this.$emit('input', value)
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/Fields/SelectDuration.vue